import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

function SpendingCategories() {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="card bg-white dark:bg-dark-surface p-8 text-center"
    >
      <h2 className="text-2xl font-bold mb-4">{t("spendingCategories", "Категорії витрат")}</h2>
      <p className="text-gray-500 dark:text-gray-400">
        {t("comingSoon", "Ця сторінка знаходиться в розробці.")}
      </p>
    </motion.div>
  );
}

export default SpendingCategories;
